<template>
  <div id="pageContent" ref="pageContent">
    <!-- <a-card :bordered="false" class="card-area"> -->
    <div class="map-layout">
      <div class="map-component">
        <MapComponent
          ref="mapComponent"
          :points="areas"
          :areasData="areasData"
          :isCommercial="applicationType"
          @resultPoint="showMapDetails"
          @mapMouseover="mapMouseover"
          @mapMouseout="mapMouseout"
        />
      </div>
      <div class="content" ref="content">
        <div class="content-left">
          <div v-if="showSrarchimg" class="searchimg" @click="onShowSrarch">
            <img src="static/img/search.png" />
          </div>
          <div v-if="showSrarch" class="content-left-search">
            <a-input-search
              v-model="searchText"
              placeholder="搜索区域名称/IMEI码"
              @search="searchArea"
            />
            <a-icon
              class="closeicon"
              type="double-left"
              style="color: #fff"
              @click="closeSearchInput"
            />
          </div>
          <transition name="left-card">
            <div v-if="showLeftCard" class="content-left-desc">
              <a-icon class="iconbtn" type="close" @click="closeleft" />
              <div class="area-desc">
                <span class="area-name">{{ areaInfo.areaName }}</span>
                <div class="area-address mpflex">
                  <span
                    >地&nbsp;&nbsp;&nbsp;址：{{ areaInfo.detailLocation }}
                  </span>
                  <a-icon
                    class="redo"
                    type="sync"
                    :spin="spin"
                    @click="refresh"
                  />
                </div>
                <!-- <div class="area-person"> -->
                <div class="area-address mpflex">
                  <span>负责人：{{ areaInfo.principal }}</span>
                  <span class="mphone"> 联系电话：{{ areaInfo.phone }} </span>
                </div>
                <div class="area-address" v-if="applicationType == 1">
                  <span
                    >电磁总阀状态：{{
                      areaInfo.valveState == 0
                        ? "未连接"
                        : areaInfo.valveState == 1
                        ? "开放"
                        : areaInfo.valveState == 1
                        ? "闭合"
                        : ""
                    }}</span
                  >
                </div>
                <!-- </div> -->
              </div>
              <div class="line">
                <span style="color: #fff" @click="showAlarmlist">
                  <a-icon
                    :class="[showAlarm ? 'icon' : 'icon1']"
                    type="double-left"
                    style="color: #fff"
                  />{{ showAlarm ? "查看警报器" : "收起警报器" }}
                </span>
              </div>
              <div v-if="!showAlarm" class="table-box">
                <a-tabs
                  v-model="activeKey"
                  @change="callback"
                  style="color: #ffffff"
                >
                  <a-tab-pane tab="报警器" key="0"></a-tab-pane>
                  <a-tab-pane tab="控制设备" key="1"></a-tab-pane>
                  <a-tab-pane tab="联动设备" key="2"></a-tab-pane>
                </a-tabs>

                <div class="table-head">
                  <span v-if="activeKey != 0">
                    <span>序列号</span>
                    <span>设备类型</span>
                    <span>连接状态</span>
                    <span>故障状态</span>
                    <span>位置</span>
                  </span>
                  <span v-else>
                    <span>报警器IMEI</span>
                    <span>综合状态</span>
                    <span v-if="applicationType == 1">电磁阀</span>
                    <span v-if="applicationType == 2">电磁阀1</span>
                    <span v-if="applicationType == 2">电磁阀2</span>
                    <span>位置</span>
                  </span>
                </div>
                <div class="table">
                  <div
                    class="table-row-box"
                    v-for="item in tableAlarmList"
                    :key="item.alarmId"
                    :style="{
                      cursor:
                        alarm.alarmId === item.alarmId ? 'unset' : 'pointer',
                    }"
                    @click="showdetector(item)"
                  >
                    <div class="table-row">
                      <!-- 设备回显数据 -->
                      <span v-if="activeKey != 0">
                        <span>{{ item.serialNumber }}</span>
                        <span>{{ item.type }}</span>
                        <render-enum
                          :showObj="
                            showEnumItem(connectState, item.connectState)
                          "
                        />
                        <render-enum
                          :showObj="
                            showEnumItem(HCRBreakDownState, item.breakdownState)
                          "
                        />
                        <span>{{ item.mountingPosition }}</span>
                      </span>
                      <span v-else>
                        <span>{{ item.imei }}</span>
                        <span :style="{ color: getCmpType(item).color }">{{
                          getCmpType(item).name
                        }}</span>
                        <render-enum
                          v-if="applicationType == 1"
                          :showObj="
                            showEnumItem(electromagnetic, item.valveState)
                          "
                        />
                        <render-enum
                          v-if="applicationType == 2"
                          :showObj="
                            showEnumItem(electromagnetic, item.valveState)
                          "
                        />
                        <render-enum
                          v-if="applicationType == 2"
                          :showObj="
                            showEnumItem(electromagnetic, item.valveState2)
                          "
                        />
                        <span>{{ item.mountingPosition }}</span>
                      </span>
                    </div>

                    <div class="rowhover" v-if="activeKey == 0">
                      <div>
                        采集器：
                        <span
                          :style="{
                            color: item.connectState ? '#009900' : '#999999',
                          }"
                          >{{ getCollectorType(item.connectState) }}</span
                        >
                      </div>
                      <div v-if="applicationType == 0">
                        报警器：
                        <span :style="{ color: getAlarmType(item).color }"
                          >{{ getAlarmType(item).name }}
                        </span>
                      </div>
                      <div v-if="applicationType == 0">
                        综合探测器：
                        <span
                          :style="{ color: getDetectorPropeType(item).color }"
                          >{{ getDetectorPropeType(item).name }}</span
                        >
                      </div>
                      <div v-if="applicationType != 0">
                        报警状态：
                        <render-enum
                          :showObj="
                            showFormatAlarm(
                              HCRAlarmState,
                              item.alarmState,
                              item.type
                            )
                          "
                        />
                      </div>
                      <div v-if="applicationType != 0">
                        故障状态：
                        <render-enum
                          :showObj="
                            showEnumItem(HCRBreakDownState, item.breakdownState)
                          "
                        />
                      </div>

                      <div v-if="applicationType == 1">
                        寿命状态：
                        <render-enum
                          :showObj="
                            showEnumItem(SensorLifeState, item.sensorLifeState)
                          "
                        />
                      </div>
                      <div v-if="applicationType == 2">
                        自检状态：
                        <render-enum
                          :showObj="
                            showEnumItem(SelfCheckState, item.selfCheckState)
                          "
                        />
                      </div>
                    </div>
                  </div>
                  <p
                    v-if="tableAlarmList.length === 0"
                    style="text-align: center; color: #888"
                  >
                    暂无数据
                  </p>
                  <div class="line"></div>
                  <div class="pagination">
                    <a-pagination
                      size="small"
                      :current="alarmPageNum"
                      :total="alarmTotal"
                      :page-size="alarmPageSize"
                      @change="onAlarmChange"
                      :showTotal="
                        (total, range) =>
                          `显示 ${range[0]} ~ ${range[1]} 条记录，共 ${total} 条记录`
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
        <!-- 点击工商业探测器列表弹框 -->
        <transition name="right-card" v-if="applicationType == 0">
          <div class="content-right" v-if="showLeftCard && showRightCard">
            <div class="content-right-head">
              <div class="back" @click="closedetector">
                <a-icon type="left" />
                <span>探测器</span>
              </div>
              <a-select
                :allowClear="true"
                size="small"
                v-model="detectorType"
                style="width: 35%"
              >
                <a-select-option
                  v-for="detector in detectorTypeList"
                  :key="detector.value"
                  >{{ detector.name }}</a-select-option
                >
              </a-select>
            </div>
            <div class="table">
              <div class="table-head">
                <span>编号</span>
                <span>位置</span>
                <!-- <span>状态</span> -->
                <span>探头</span>
                <span>浓度</span>
                <span>更新时间</span>
                <span>趋势</span>
              </div>
              <div class="table-row-warp">
                <div
                  class="table-row"
                  v-for="item in tableDetectorList"
                  :key="item.id"
                >
                  <span>{{ item.number }}</span>
                  <span>{{ item.mountingPosition }}</span>
                  <!-- <span>广东省广州市越秀区寺右新马路114号 -2广东省广州市越秀区寺右新马路114号-2舒适化说是什么说明书上</span> -->
                  <span :style="{ color: getDetectorType(item).color }">{{
                    getDetectorType(item).name
                  }}</span>
                  <span
                    >{{ item.gasSpecies || "--" }}:{{
                      item.concentration || "--"
                    }}
                    {{ item.targetUnit }}</span
                  >
                  <span>{{ item.updateTime || "--" }}</span>
                  <span
                    class="show-history"
                    style="color: #1890ff"
                    @click="historyShow(item, applicationType)"
                    >查看</span
                  >
                </div>
              </div>
              <p
                v-if="tableDetectorList.length === 0"
                style="text-align: center; color: #888"
                class="nodata"
              >
                暂无数据
              </p>
            </div>
            <div class="pagination">
              <a-pagination
                size="small"
                :current="detectorPageNum"
                :total="detectorTotal"
                @change="onDetectorChange"
                :showTotal="
                  (total, range) =>
                    `显示 ${range[0]} ~ ${range[1]} 条记录，共 ${total} 条记录`
                "
              />
            </div>
          </div>
        </transition>

        <!-- 点击家用探测器弹窗 -->
        <transition
          name="right-card"
          v-if="applicationType !== 0 && activeKey == 0"
        >
          <div class="content-right" v-if="showLeftCard && showRightCard">
            <div class="content-right-head">
              <div class="back" @click="closedetector">
                <a-icon type="left" />
                <span>气体检测</span>
              </div>
            </div>
            <div class="table-gas">
              <div class="table-gas-head">
                <span>编号</span>
                <span>气体类型</span>
                <span>浓度</span>
                <span>更新时间</span>
                <span>趋势</span>
              </div>
              <div
                class="table-gas-row"
                v-for="item in newHouseholdDetectorList"
                :key="item.number"
              >
                <span>{{ item.number }}</span>
                <span>{{ item.gasSpecies }}</span>
                <span
                  >{{ item.concentration || "--" }} {{ item.targetUnit }}</span
                >
                <span>{{ item.updateTime }}</span>
                <span
                  class="show-history"
                  style="color: #1890ff"
                  @click="historyShow(item, applicationType)"
                  >查看</span
                >
                <!-- <span style="color:#1890FF">查看</span> -->
              </div>
              <p
                v-if="newHouseholdDetectorList.length === 0"
                style="text-align: center; color: #888"
              >
                暂无数据
              </p>
            </div>
            <div class="pagination">
              <a-pagination
                size="small"
                :current="houseHoldDetectorPageNum"
                :total="houseHoldDetectorTotal"
                @change="houseHoldDetectorChange"
                :showTotal="
                  (total, range) =>
                    `显示 ${range[0]} ~ ${range[1]} 条记录，共 ${total} 条记录`
                "
              />
            </div>
          </div>
        </transition>
        <!-- </div> -->
      </div>
      <div
        class="event-panel"
        :style="{ height: showEvent ? contentHeight : '60px' }"
      >
        <transition name="event-list">
          <div class="event" v-if="showEvent">
            <div class="event-head">
              <a-icon
                class="icon"
                type="double-right"
                @click="closeEventCard"
              />
              <div
                :class="msgKey == 0 ? 'event-head-title' : ''"
                style="cursor: pointer"
                @click="onAlarmMsg"
              >
                <a-badge :count="eventList.length" :offset="[12, 0]"
                  >报警器消息</a-badge
                >
              </div>
              <div
                :class="msgKey == 1 ? 'event-head-title' : ''"
                style="cursor: pointer"
                @click="onDvcMsg"
              >
                <a-badge :count="dvcList.length" :offset="[12, 0]"
                  >设备消息</a-badge
                >
              </div>
              <a-checkbox
                v-if="isCheckAll"
                :indeterminate="indeterminate"
                :checked="this.msgKey == 1 ? checkAll1 : checkAll"
                @change="onCheckAllChange"
                style="color: #ffffff"
                >全选</a-checkbox
              >

              <!-- 占位 -->
              <span v-else style="width: 3vw"></span>
            </div>
            <div
              class="event-list-panel"
              v-if="msgKey == 0 && eventList.length > 0"
            >
              <a-checkbox-group
                class="event-list-panel"
                v-model="checkedList"
                @change="onChange"
              >
                <a-timeline class="event-list">
                  <a-timeline-item
                    class="event-wrap"
                    v-for="item in eventList"
                    :key="item.alarmEventId"
                  >
                    <!-- <span class="event-time">{{item.createTime}}</span> -->
                    <div class="time-box">
                      <span>{{ item.createTime }}</span>
                      <a-checkbox :value="item.alarmEventId" />
                    </div>
                    <div
                      class="event-desc"
                      :style="{ 'background-color': getEventType(item).color }"
                      @click="checkEvent(item)"
                    >
                      <span>{{ item.areaName || "--" }}</span>
                      <span>报警器：{{ item.imei }}</span>
                      <span
                        >事件：{{
                          `${
                            item.detectorNumber
                              ? "探测器" + item.detectorNumber
                              : ""
                          }${getEventType(item).name}`
                        }}</span
                      >
                      <span>位置：{{ item.mountingPosition }}</span>
                      <!-- <span>位置：广东省广州市越秀区德政中路388号广东省广州市越秀区德政中路388号 </span> -->
                    </div>
                    <!--   <a-icon class="doticon"
                          slot="dot"
                          type="clock-circle-o" /> -->
                  </a-timeline-item>
                </a-timeline>
              </a-checkbox-group>
              <div class="event-list-foot">
                <p class="eventfoot">
                  {{
                    eventList.length >= eventPageSize
                      ? `当前显示前${eventPageSize}条事件`
                      : `当前显示${eventList.length}条数据`
                  }}{{
                    checkedList.length > 0
                      ? `，已选择${checkedList.length}条`
                      : ""
                  }}
                </p>
                <template v-if="applicationType == 0">
                  <a-button
                    class="clearbtn"
                    v-hasPermission="'alarmEventIndustry:clear'"
                    type="primary"
                    size="small"
                    :disabled="clearBtnDisable"
                    @click="clearRecord"
                    >清除记录</a-button
                  >
                </template>
                <template v-if="applicationType == 1">
                  <a-button
                    class="clearbtn"
                    v-hasPermission="'alarmEventHousehold:clear'"
                    type="primary"
                    size="small"
                    :disabled="clearBtnDisable"
                    @click="clearRecord"
                    >清除记录</a-button
                  >
                </template>
                <template v-if="applicationType == 2">
                  <a-button
                    class="clearbtn"
                    v-hasPermission="'alarmEventRestaurantList:clear'"
                    type="primary"
                    size="small"
                    :disabled="clearBtnDisable"
                    @click="clearRecord"
                    >清除记录</a-button
                  >
                </template>
              </div>
            </div>
            <div
              class="event-list-panel"
              v-else-if="msgKey == 1 && dvcList.length > 0"
            >
              <a-checkbox-group
                class="event-list-panel"
                v-model="checkedList1"
                @change="onChange"
              >
                <a-timeline class="event-list">
                  <a-timeline-item
                    class="event-wrap"
                    v-for="item in dvcList"
                    :key="item.id"
                  >
                    <div class="time-box">
                      <span>{{ item.createTime }}</span>
                      <a-checkbox :value="item.id" />
                    </div>
                    <div
                      class="event-desc"
                      :style="{
                        'background-color': getDvcEventType(item).color,
                      }"
                      @click="checkEvent(item)"
                    >
                      <span>{{ item.areaName || "--" }}</span>
                      <span
                        >设备类型：{{
                          item.dvcType == 1 ? "控制设备" : "联动设备"
                        }}</span
                      >
                      <span>事件：{{ `${getDvcEventType(item).name}` }}</span>
                      <span>位置：{{ item.mountingPosition }}</span>
                    </div>
                  </a-timeline-item>
                </a-timeline>
              </a-checkbox-group>
              <div class="event-list-foot">
                <p class="eventfoot">
                  {{
                    dvcList.length >= eventPageSize
                      ? `当前显示前${eventPageSize}条事件`
                      : `当前显示${dvcList.length}条数据`
                  }}{{
                    checkedList1.length > 0
                      ? `，已选择${checkedList1.length}条`
                      : ""
                  }}
                </p>
                <template v-if="dvcList.length">
                  <a-button
                    class="clearbtn"
                    type="primary"
                    size="small"
                    v-hasPermission="'dvcEvent:clear'"
                    :disabled="clearDvcBtnDisable"
                    @click="clearRecord"
                    >清除记录</a-button
                  >
                </template>
              </div>
            </div>
            <p style="text-align: center; margin-top: 5px" v-else>暂无消息</p>
          </div>
        </transition>
      </div>
      <transition name="event-btn">
        <div class="event-btn" v-if="!showEvent" @click="showEventCard">
          <span>事件消息</span>
          <a-icon class="icon" type="double-left" style="color: #fff" />
        </div>
      </transition>
    </div>
    <MonitiorHistory
      :historyVisiable="historyVisiable"
      :detector="detector"
      :showType="lineChart"
      :currentConcentration="currentConcentration"
      @close="historyClose"
    />
    <MapMarkHover
      :applicationType="applicationType"
      :mapMouseoverObj="mapMouseoverObj"
    />
    <password-validation-modal
      :visible="passwordModalVisible"
      :checkNum="
        this.msgKey == 1 ? this.checkedList1.length : this.checkedList.length
      "
      @onPasswordHide="onPasswordHide"
      @onPasswordOk="onPasswordOk"
    />
  </div>
</template>

<script>
import MapComponent from "../MapComponent";
import monitorType from "../../business/monitor/monitorType";
import MonitiorHistory from "./MonitiorHistory";
import passwordValidationModal from "../../../components/modals/passwordvalidationmodal.vue";
import MapMarkHover from "./MapMarkHover";
import renderEnum from "./renderEnum.vue";
let that;
export default {
  name: "Map",
  components: {
    MapComponent,
    MonitiorHistory,
    passwordValidationModal,
    MapMarkHover,
    renderEnum,
  },
  props: {
    isCommerceType: {
      default: "",
    },
  },
  data() {
    return {
      activeKey: "0",
      msgKey: 0,
      areas: [], // 地图点数据
      spin: false,
      spinning: true,
      showAlarm: false,
      eventclick: false,
      enentlng: "",
      enentlat: "",
      interval: "",
      contentHeight: "0px", // 地图高度
      applicationType: null,
      searchText: "", // 搜索区域名称文本
      showLeftCard: false, // 是否展示区域左边块
      showRightCard: false, // 是否展示区域右边块
      areaInfo: {}, // 选中区域
      alarmPageSize: 8, // 报警器每页条数
      alarmPageNum: 1, // 报警器页码
      alarmTotal: 0, // 报警器总数
      tableAlarmList: [], // 报警器列表
      alarm: {}, // 选中报警器对象
      detectorType: "", // 探测器类型Id
      detectorPageSize: 10, // 探测器每页条数
      detectorPageNum: 1, // 探测器页码
      detectorTotal: 0, // 探测器总数
      showEvent: false, // 是否展示事件消息
      eventList: [], // 事件消息列表
      dvcList: [], //设备消息列表
      eventPageSize: 100, // 事件条数
      historyVisiable: false, // 是否展示探测器历史数据
      detector: {}, // 选中探测器对象
      showSrarch: false,
      showSrarchimg: true,
      tableDetectorList: [],
      mapMouseoverObj: { x: "-999", y: "0", data: {} },
      areasData: [], // 循环的数据，用于点颜色同步
      indeterminate: false,
      checkAll: false,
      checkAll1: false, //设备信息全选
      checkedList: [],
      checkedList1: [], //设备信息选中
      clearBtnDisable: true,
      clearDvcBtnDisable: true,
      isSearchParams: false,
      Params: null,
      newHouseholdDetectorList: [],
      houseHoldDetectorTotal: 0,
      houseHoldDetectorPageSize: 10,
      houseHoldDetectorPageNum: 1,
      passwordModalVisible: false,
      lineChart: "0",
      currentConcentration: {},
    };
  },
  watch: {
    isCommerceType: {
      handler(val, oldval) {
        this.applicationType = val;
        console.log("类型--->", val, this.applicationType);
        this.loadData();
        setTimeout(() => {
          this.showLeftCard = false;
          this.showSrarchimg = true;
          this.showSrarch = false;
          // this.showEvent = false
          this.showRightCard = false;
        }, 100);
      },
      immediate: true,
    },
    detectorType(val) {
      console.log("报警状态", val);
      this.detectorPageNum = 1;
      this.getDetectorList();
    },
    checkedList(val) {
      this.clearBtnDisable = !val.length;
    },
    checkedList1(val) {
      this.clearDvcBtnDisable = !val.length;
    },
  },
  computed: {
    HCRAlarmState() {
      return monitorType.HCRAlarmState;
    },
    HCRBreakDownState() {
      return monitorType.HCRBreakDownState;
    },
    SensorLifeState() {
      return monitorType.SensorLifeState;
    },
    SelfCheckState() {
      return monitorType.SelfCheckState;
    },
    electromagnetic() {
      return monitorType.electromagnetic;
    },
    detectorTypeList() {
      // 探测器类型列表
      return monitorType.detectorType;
    },
    cmpTypeList() {
      // 探测器类型列表
      return monitorType.cmpType;
    },
    alarmTypeList() {
      //报警器类型列表
      let applicationType = this.applicationType;
      if (applicationType == 0) {
        return monitorType.commerceAlarmType;
      }
      if (applicationType == 1) {
        return monitorType.householdAlarmType;
      }
    },
    detectorPropeTypeList() {
      // 报警器探头类型列表
      return monitorType.detectorType;
    },
    eventTypeList() {
      return this.applicationType == 0
        ? monitorType.commerceEvent
        : this.applicationType == 1
        ? monitorType.householdEvent
        : monitorType.commerceRestaurantEvent;
    },
    // 连接状态
    connectState() {
      return monitorType.CollectorState;
    },
    isCheckAll() {
      if (this.msgKey == 0 && this.eventList.length) {
        return true;
      } else if (this.msgKey == 1 && this.dvcList.length) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    that = this;
    setTimeout(() => {
      this.loadData();
    }, 100);
  },
  methods: {
    onAlarmMsg() {
      this.msgKey = 0;
    },
    onDvcMsg() {
      this.msgKey = 1;
    },
    callback(key) {
      this.activeKey = key;
      this.getAreaDetial();
    },
    // 处理枚举显示
    showEnumItem(obj, val) {
      let resObj = {};
      // console.log("obj--", obj);
      try {
        resObj.text = obj[val].name;
        resObj.color = obj[val].color;
      } catch (error) {
        resObj.text = "--";
        resObj.color = "";
      }
      return resObj;
    },
    showFormatAlarm(obj, val, type) {
      let alarmObj = {};
      try {
        alarmObj.text = obj[val].name;
        alarmObj.color = obj[val].color;
        if (val == 1) {
          alarmObj.text = type == 1 ? "报警" : "低限报警";
        }
      } catch (error) {
        alarmObj.text = "--";
        alarmObj.color = "";
      }
      return alarmObj;
    },
    refresh() {
      this.spin = true;
      this.alarmPageNum = 1;
      this.Params = {
        areaId: this.areaInfo.areaId,
        type: this.applicationType,
      };
      this.getAreaDetial();
    },
    getvalveState(text) {
      switch (text) {
        case 0:
          return "未连接";
        case 1:
          return "开放";
        case 2:
          return "闭合";
      }
    },
    closeleft() {
      this.showLeftCard = false;
      this.showRightCard = false;
      this.showSrarch = true;
      this.$refs.mapComponent.clearAnimation();
    },
    getAlarmType(item) {
      // 获取报警器类型对象
      let index = this.alarmTypeList.findIndex((alarm) => {
        return alarm.value == item.state;
      });
      return index > -1
        ? this.alarmTypeList[index]
        : { name: "-", color: "#ccc" };
    },
    getCollectorType(text) {
      // 获取采集器状态
      switch (text) {
        case 0:
          return "离线";
        case 1:
          return "在线";
      }
    },
    getCmpType(item) {
      // 获取综合状态类型对象
      let index = this.cmpTypeList.findIndex((prope) => {
        return prope.name == item.cmpState;
      });
      return index > -1
        ? this.cmpTypeList[index]
        : { name: "-", color: "#ccc" };
    },
    getDetectorPropeType(item) {
      //获取报警器探头类型对象
      // console.log("item->", item.detectorState);
      let index = this.detectorPropeTypeList.findIndex((prope) => {
        return prope.name == item.detectorState;
      });
      // console.log("detectorPropeTypeList", index);
      return index > -1
        ? this.detectorPropeTypeList[index]
        : { name: "-", color: "#ccc" };
    },
    getDetectorType(item) {
      // 获取探测器类型对象
      let index = this.detectorTypeList.findIndex((detector) => {
        return detector.value == item.state;
      });
      return index > -1
        ? this.detectorTypeList[index]
        : { name: "-", color: "#ccc" };
    },
    getEventType(item) {
      let index = this.eventTypeList.findIndex((event) => {
        return item.alarmEventType == event.value;
      });
      if (index > -1) {
        let enevtObj = JSON.parse(JSON.stringify(this.eventTypeList[index]));
        if (item.alarmEventType == 7 && item.valveNumber) {
          enevtObj.name = `电磁阀${item.valveNumber}打开`;
        }
        if (item.alarmEventType == 8 && item.valveNumber) {
          enevtObj.name = `电磁阀${item.valveNumber}关闭`;
        }
        return enevtObj;
      } else {
        return { name: "-", color: "#ccc" };
      }
    },
    // 设备事件处理
    getDvcEventType(item) {
      let index = monitorType.dvcEvent.findIndex((event) => {
        return item.eventType == event.value;
      });
      if (index > -1) {
        let eventObj = JSON.parse(JSON.stringify(monitorType.dvcEvent[index]));
        return eventObj;
      } else {
        return { name: "-", color: "#ccc" };
      }
    },
    loadData() {
      this.loadAreaData();
      this.getEventList();
      this.getDvcEventList();
    },

    loadAreaData() {
      // 获取地图数据
      clearTimeout(this.interval);
      this.interval = "";
      this.spinning = true;
      this.$get("monitor/getAreaInfo", {
        type: this.applicationType,
      })
        .then((res) => {
          this.areas = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 轮询地图点数据
    loopAreaData() {
      this.$get("monitor/getAreaInfo", {
        type: this.applicationType,
      }).then((res) => {
        this.areasData = res.data;
        // this.loopFunc(this.loopAreaData);
      });
    },
    closeSearchInput() {
      this.showSrarch = false;
      this.showSrarchimg = true;
    },
    onShowSrarch() {
      this.showSrarchimg = false;
      this.showSrarch = true;
      this.$refs.mapComponent.clearAnimation();
    },
    getEventList() {
      // 获取事件消息
      let applicationType = this.applicationType;
      let getEventListApi =
        applicationType == 0
          ? "monitor/getAlarmEventIndustryList"
          : applicationType == 1
          ? "monitor/getAlarmEventHouseholdList"
          : "monitor/getAlarmEventRestaurantList";
      this.$get(getEventListApi, {
        isOver: false,
        pageNum: 1,
        pageSize: this.eventPageSize,
      }).then((res) => {
        this.eventList = res.data.rows;
        if (res.data.rows.length > 0) {
          this.showEvent = true;
        }
        // this.loopFunc(this.getEventList);
        if (this.interval) {
          clearTimeout(this.interval);
        }
        this.interval = setTimeout(() => {
          this.getEventList();
          this.loopAreaData();
          this.getDvcEventList();
        }, monitorType.LOOP_INTERVAL);
      });
    },
    // 设备消息
    getDvcEventList() {
      this.$get("/monitor/getDvcEventList", {
        areaType: this.applicationType,
        isClear: false,
        pageNum: 1,
        pageSize: this.eventPageSize,
      }).then((res) => {
        this.dvcList = res.data.rows;
      });
    },
    getAreaDetial(param = {}, isSearch = false) {
      console.log("点击地图的点", param);
      // this.eventclick = false
      this.tableAlarmList = [];
      this.areaInfo = {};
      this.alarmTotal = 0;
      let api = "monitor/getAreaWithAlarmInfo";
      if (this.activeKey == 1) {
        api = "monitor/getAreaWithCtrlDvcInfo";
      } else if (this.activeKey == 2) {
        api = "monitor/getAreaWithLinkDvcInfo";
      }
      //获取区域详情
      this.$get(api, {
        pageSize: this.alarmPageSize,
        pageNum: this.alarmPageNum,
        ...this.Params,
      })
        .then((res) => {
          this.areaInfo = res.data.areaInfo;
          this.alarmTotal = res.data.total;
          this.tableAlarmList = res.data.rows;
          if (this.areaInfo) {
            this.showLeftCard = true;
            this.showSrarch = false;
            this.showSrarchimg = false;
            if (this.showRightCard) {
              let index = this.tableAlarmList.findIndex((item) => {
                return item.alarmId == this.alarm.alarmId;
              });
              this.alarm = index > -1 ? this.tableAlarmList[index] : {};
            }
            if (this.isSearchParams) {
              this.$refs.mapComponent.moveToPoint(res.data.areaInfo);
            }
          } else {
            this.showLeftCard = false;
            this.showRightCard = false;
            this.$message.warning("不存在该区域");
          }
        })
        .finally(() => {
          this.spin = false;
        });
    },
    searchArea() {
      this.$refs.mapComponent.clearAnimation();
      this.showRightCard = false;
      if (!this.searchText) {
        this.$message.warning("请输入区域/IMEI码");
        this.showLeftCard = false;
        return;
      }
      this.alarmPageNum = 1;
      this.isSearchParams = true;
      this.Params = {
        value: this.searchText,
        type: this.applicationType,
      };
      this.getAreaDetial();
    },
    onAlarmChange(page) {
      this.alarmPageNum = page;
      this.alarm = {};
      this.showRightCard = false;
      this.Params = {
        areaId: this.areaInfo.areaId,
        type: this.applicationType,
      };
      this.getAreaDetial();
    },
    onDetectorChange(page) {
      this.detectorPageNum = page;
      this.getDetectorList();
    },

    showMapDetails(warningDevice) {
      this.showLeftCard = true;
      this.showEvent = true;
      this.showRightCard = false;
      this.alarm = {};
      this.alarmPageNum = 1;
      this.isSearchParams = false; // 点击地图坐标点用id
      this.Params = {
        areaId: warningDevice.areaId,
        type: this.applicationType,
      };
      this.getAreaDetial();
    },

    showdetector(item) {
      this.alarm = item;
      // 选中报警器，展示探测器
      if (this.activeKey == 0) {
        if (this.applicationType == 1) {
          this.houseHoldDetectorPageNum = 1;
          this.checkHouseholdDetector();
        } else if (this.applicationType == 0) {
          this.detectorPageNum = 1;
          this.detectorType = "";
          console.log("探测器", item);
          this.getDetectorList();
        } else {
          this.houseHoldDetectorPageNum = 1;
          this.getHouseholdDetectorList();
        }
      }
    },
    // 判断家用探测器新旧
    checkHouseholdDetector() {
      this.$get("monitor/isNewHousehold", { alarmId: this.alarm.alarmId }).then(
        (res) => {
          if (res.data) {
            this.getHouseholdDetectorList();
          } else {
            this.$message.warning("该款报警器不支持浓度显示");
            this.showRightCard = false;
          }
        }
      );
    },

    // 获取家用探测器列表
    getHouseholdDetectorList() {
      let param = {
        alarmId: this.alarm.alarmId,
        pageSize: this.houseHoldDetectorPageSize,
        pageNum: this.houseHoldDetectorPageNum,
      };
      let api = "monitor/getNewHouseholdDetectorList";
      if (this.applicationType == 2) {
        api = "monitor/getRestaurantDetectorList";
      }
      this.$get(api, param).then((res) => {
        this.showRightCard = true;
        this.newHouseholdDetectorList = res.data.rows;
        this.houseHoldDetectorTotal = res.data.total;
      });
    },

    // 获取工商业探测器列表
    getDetectorList() {
      let param = {
        alarmId: this.alarm.alarmId,
        detectorState: this.detectorType,
        pageSize: this.detectorPageSize,
        pageNum: this.detectorPageNum,
      };
      this.$get("/monitor/getMapDetectorList", param)
        .then((res) => {
          this.tableDetectorList = res.data.rows;
          this.detectorTotal = res.data.total;
          console.log("tableDetectorList", res.data.rows);
        })
        .catch(() => {
          this.tableDetectorList = [];
          this.detectorTotal = 0;
        })
        .finally(() => {
          this.showRightCard = true;
        });
    },
    closedetector() {
      this.showRightCard = false;
    },
    historyShow(item, type) {
      // 展示探测器详情折线图
      let targetUnit = item.targetUnit || "";
      let val = `${item.concentration} ${targetUnit}`;
      let showConcentration = {
        value: val,
        time: item.updateTime,
      };
      this.currentConcentration = showConcentration;
      this.lineChart = type;
      this.detector = item;
      this.historyVisiable = true;
    },
    historyClose() {
      this.historyVisiable = false;
    },
    showEventCard() {
      // 展示事件消息
      this.showEvent = true;
    },
    closeEventCard() {
      this.showEvent = false;
      this.eventclick = false;
    },
    checkEvent(item) {
      /* this.showLeftCard = true
      this.showEvent = true */
      // 选中事件
      this.showRightCard = false;
      this.searchText = item.imei;
      this.alarmPageNum = 1;
      this.isSearchParams = false;
      this.activeKey = "0"; // 默认报警器
      this.Params = {
        value: item.areaName,
        type: this.applicationType,
        areaId: item.areaId,
      };
      this.getAreaDetial();
      this.$refs.mapComponent.moveToPoint(item);
    },
    //选中记录
    onChange(checkedValues) {
      console.log("checked = ", checkedValues);
      if (this.msgKey == 0) {
        this.indeterminate =
          !!checkedValues.length &&
          checkedValues.length < this.eventList.length;
        this.checkAll = checkedValues.length === this.eventList.length;
        this.checkedList = checkedValues;
      } else {
        this.indeterminate =
          !!checkedValues.length && checkedValues.length < this.dvcList.length;
        this.checkAll1 = checkedValues.length === this.dvcList.length;
        this.checkedList1 = checkedValues;
      }
    },
    //全选
    onCheckAllChange(e) {
      let allcheckedList = [];
      if (this.msgKey == 0) {
        this.eventList.forEach((item) => {
          allcheckedList.push(item.alarmEventId);
          console.log("alarmEventId--", item.alarmEventId);
        });
        Object.assign(this, {
          checkedList: e.target.checked ? allcheckedList : [],
          indeterminate: false,
          checkAll: e.target.checked,
        });
      } else {
        this.dvcList.forEach((item) => {
          allcheckedList.push(item.id);
          console.log("alarmEventId--", item.alarmEventId);
        });
        Object.assign(this, {
          checkedList1: e.target.checked ? allcheckedList : [],
          indeterminate: false,
          checkAll1: e.target.checked,
        });
      }
      console.log("allclick", this.checkedList);
    },
    //清除记录
    clearRecord() {
      console.log("要删除的记录id", this.checkedList);
      this.passwordModalVisible = true;
    },
    onPasswordOk(password) {
      let eventIds =
        this.msgKey == 1 ? [...this.checkedList1] : [...this.checkedList];
      console.log("删除", eventIds, password);
      this.$post(
        this.msgKey == 1
          ? "/monitor/clearDvcEvent"
          : this.applicationType == 0
          ? "monitor/clearAlarmEventIndustry"
          : this.applicationType == 1
          ? "monitor/clearAlarmEventHousehold"
          : "monitor/clearAlarmEventRestaurant",
        { eventIds, password, clearReason: 1 }
      )
        .then((res) => {
          this.passwordModalVisible = false;
          if (this.msgKey == 1) {
            this.getDvcEventList();
            this.checkedList1 = [];
          } else {
            this.getEventList();
            this.checkedList = [];
          }
        })
        .finally(() => {
          if (this.msgKey == 1) {
            this.checkAll1 = false;
          } else {
            this.checkAll = false;
          }
        });
    },
    onPasswordHide() {
      this.passwordModalVisible = false;
    },
    showAlarmlist() {
      this.showAlarm = !this.showAlarm;
    },

    // 鼠标移入标点
    mapMouseover(dataObj) {
      this.mapMouseoverObj = dataObj;
    },
    // 鼠标移出标点
    mapMouseout() {
      this.mapMouseoverObj.x = "-9999";
    },
    houseHoldDetectorChange(page) {
      this.houseHoldDetectorPageNum = page;
      this.getHouseholdDetectorList();
    },
  },
  beforeRouteLeave(to, from, next) {
    clearTimeout(this.interval);
    this.interval = "";
    next();
  },
  destroyed() {
    clearTimeout(this.interval);
    this.interval = "";
  },
};
</script>

<style lang="less" scoped>
@import "~@/utils/utils.less";
/deep/ .ant-select-selection:hover {
  opacity: 0.9;
}

/deep/ .anchorBL {
  display: none;
}
/deep/ .ant-pagination-item a {
  color: white;
  font-size: 0.5vw;
}
/deep/ .ant-pagination-item {
  background-color: rgb(24, 23, 71);
  // font-size: 0.5vw;
  // line-height: 2vh;
  height: 2vh;
}
/deep/ .ant-select-selection--single {
  background-color: rgb(24, 23, 71);
  color: white;
  height: 2vh;
}
/deep/ .ant-select-selection__rendered {
  line-height: 2vh;
}
/deep/ .ant-select-selection__rendered {
  font-size: 0.4vw;
}
/deep/ .anticon {
  color: white;
}
/deep/ .ant-timeline-item-head-custom {
  top: 0.2vw;
  // right: 0.3vw;
}
/deep/ .ant-timeline-item-content {
  margin: 0 0 0 0.7vw;
}
/deep/ .ant-input {
  color: rgba(250, 248, 248, 0.65);
  background-color: #002269;
  background-image: none;
  border: 1px solid #2a3fff;
  border-radius: 4px;
}
.show-history {
  cursor: pointer;
}
.table-row-box {
  &:hover {
    cursor: pointer;
    background-color: rgb(68, 102, 175);
    .rowhover {
      display: block;
    }
  }
}
.rowhover {
  display: none;
  position: absolute;
  left: 5vw;
  // top: 100px;
  padding: 0.5vw;
  border-radius: 0.2vw;
  background-color: rgb(41, 44, 185);
  box-shadow: 0px 0px 10px #161e46;
  z-index: 999;
  font-size: 0.6vw;
  div {
    margin: 0.3vw 0;
  }
}
.show {
  opacity: 1;
}
.iconbtn {
  color: white;
  position: absolute;
  z-index: 9999;
  right: 0;
  margin: 0.4vw 0.5vw 0 0;
  font-size: 0.5vw;
  &:hover {
    cursor: pointer;
  }
}
#pageContent {
  height: 100%;
}
.map-layout {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0px;
  overflow: hidden;
  // background-color: #fff;
  color: #666;
  position: relative;
}
.map-component {
  width: 100%;
  height: 100%;
  overflow: hidden;
  user-select: none;
  position: relative;
  z-index: 0;
}
.content {
  top: 0;
  left: 10px;
  position: absolute !important;
  display: flex;
  z-index: 1000; 
  .content-left {
    margin: 15px 0;
    width: 18vw;
    min-width: 400px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    .searchimg {
      width: 1.8vw;
      height: 1.8vw;
      padding: 0.35vw;
      display: flex;
      align-content: center;
      justify-content: center;
      background-color: rgba(9, 15, 99, 0.9);
      border: 1px #2a27f3 solid;
      border-radius: 5px;
      &:hover {
        cursor: pointer;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
    .content-left-search {
      // width: 100%;
      width: 12vw;
      height: 1.5vw;
      display: flex;
      align-items: center;
      background-color: rgba(9, 15, 99, 0.4);
      opacity: 0.9;
      // box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.349019607843137);
      border-radius: 2px;
      border: 1px #2a27f3 solid;
      padding: 20px 10px;
      & .closeicon {
        margin-left: 10px;
        font-size: 0.8vw;
        &:hover {
          cursor: pointer;
        }
      }
      & input {
        flex: 1;
        border: none;
        outline: none;
        font-size: 0.8vw;
      }
    }
    .content-left-desc {
      // flex: 1;
      width: 100%;
      // margin-top: 5px;
      background-color: #000033;
      // background: #000;
      opacity: 0.9;
      border: 0.1vw solid #00baff;
      padding-bottom: 15px;
      border-radius: 2px;
      z-index: 99;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      color: white;
      .area-desc {
        width: 100%;
        height: 10vh;
        // background-color: #ddd;
        padding: 0.6vw;
        display: flex;
        flex-direction: column;
        // font-size: 13px;
        color: #fff;
        .area-name {
          font-size: 0.8vw;
          height: 1vw;
          line-height: 1vw;
          margin-bottom: 10px;
        }
        .area-address {
          font-size: 0.6vw;
          line-height: 1.35vw;
          flex: 1;
          width: 100%;
          display: flex;
          align-items: center;
          // background-color: #fff;
          position: relative;
          & span {
            .textOverflow();
          }
        }
        .area-person {
          flex: 1;
          width: 100%;
          display: flex;
          .area-personname,
          .area-phone {
            width: 45%;
            height: 100%;
            display: flex;
            align-items: center;
          }
          .area-phone {
            background-color: #fff;
            width: 100%;
            position: relative;
          }
        }
      }
      & img {
        width: 20px;
        height: 20px;
        margin-right: 5px;
      }
      .table {
        width: 100%;
        color: white;
        flex: 1;
        overflow: hidden;
        // overflow-y: auto;
      }
      .table-head,
      .table-row {
        width: 100%;
        padding: 0.4vw 0;
        /* height: 3vh;
        line-height: 3vh; */
        display: flex;
        color: white;
        // background-color: rgb(87, 78, 78);
        & span:first-child {
          flex: 3;
          text-align: center;
        }
        & span:nth-child(2) {
          flex: 2;
          text-align: center;
        }
        & span {
          flex: 2;
          text-align: center;
        }
        & span:last-child {
          flex: 5;
          padding: 0 6px;
          display: flex;
          justify-content: center;
        }
      }
      .table-head {
        color: white;
        font-weight: 550;
        font-size: 0.6vw;
      }
      .table-row {
        font-size: 0.55vw;
      }
    }
  }
  .content-right {
    width: 24vw;
    min-width: 590px;
    // margin-left: 5px;
    background-color: #000033;
    opacity: 0.9;
    // margin-top: 1vw;
    margin: 15px 0;
    border: 0.1vw solid #00baff;
    border-radius: 2px;
    padding: 0.5vw;
    .content-right-head {
      width: 100%;
      height: 54px;
      font-size: 0.6vw;
      // background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 10px;
      .back {
        cursor: pointer;
        color: #ffffff;
      }
    }
    .table {
      width: 100%;
      color: #ffffff;
      .table-head,
      .table-row {
        width: 100%;
        padding: 0.4vw 0;
        /*  height: 3vh;
        line-height: 3vh; */
        display: flex;
        & span:first-child {
          width: 10%;
          text-align: center;
        }
        & span:nth-child(2) {
          width: 45%;
          display: flex;
          justify-content: center;
        }
        & span:nth-child(3) {
          width: 15%;
          text-align: center;
        }
        & span:nth-child(4) {
          width: 20%;
          text-align: center;
          // background-color: aquamarine;
        }
        & span:nth-child(5) {
          width: 20%;
          text-align: center;
          // background-color: aquamarine;
        }
        & span:last-child {
          width: 10%;
          text-align: center;
          cursor: pointer;
        }
      }
      .table-head {
        color: white;
        font-weight: 550;
        font-size: 0.6vw;
      }
      .table-row {
        font-size: 0.55vw;
      }
      .table-row-warp {
        max-height: 66vh;
        overflow: hidden;
        overflow-y: auto;
      }
    }
    .table-gas-head,
    .table-gas-row {
      width: 100%;
      // padding: 8px 0;
      display: flex;
      justify-content: space-evenly;
      color: #fff;
      // background-color: aquamarine;
      span {
        flex: 1;
        text-align: center;
      }
    }
  }
}
.event-panel {
  top: 0;
  right: 10px;
  position: absolute !important;
  z-index: 1001; /* 确保显示在地图上面 */
  color: white;
  .event {
    // background-color: whitesmoke;
    width: 12.7vw;
    min-width: 325px;
    // height: calc(100% - 20px);
    margin: 10px 0;
    background-color: #000033;
    opacity: 0.9;
    // box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.349019607843137);
    border: 0.1vw solid#00baff;
    border-radius: 4px;
    padding-bottom: 5px;
    .event-head {
      width: 100%;
      height: 4vh;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 10px;
      // opacity: 1;
      i {
        font-size: 0.6vw;
      }
      .icon {
        // font-size: 0.5vw;
        width: 1vw;
        height: 1vw;
        .flexCenter();
        cursor: pointer;
      }
      .event-head-title {
        // flex: 1;
        height: 1vw;
        // padding-right: 1vw;
        // background-color: #fff;
        .flexCenter();
        & span {
          font-size: 0.7vw;
          width: 3.5vw;
          text-align: center;
          padding-bottom: 1px;
          border-bottom: 0.2vw solid #1890ff;
        }
      }
    }
    .event-list-foot {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .event-list-panel {
      padding: 0 0.2vw;
      margin-top: 0.2vw;
      width: 100%;
      height: 80vh;
      display: flex;
      flex-direction: column;
      .event-list {
        // width: 100%;
        padding: 0.2vw 0.3vw 0;
        flex: 1;
        overflow-y: auto;
        .event-wrap {
          width: 100%;
          display: flex;
          flex-direction: column;
          .time-box {
            display: flex;
            justify-content: space-between;
            color: rgb(255, 255, 255);
          }
          .doticon {
            color: red;
            font-size: 0.6vw;
          }
          .event-time {
            color: #ffffff;
            font-size: 0.6vw;
          }
          .event-desc {
            // background-color: #fff;
            width: 100%;
            // height: 9vh;
            padding: 0.2vw 0.3vw;
            margin-top: 5px;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            font-size: 0.6vw;
            border-radius: 4px;
            color: #fff;
            // opacity: 0.8;
            cursor: pointer;
            & span {
              width: 100%;
              // .textOverflow();
            }
          }
        }
      }
    }
  }
}
.eventfoot {
  text-align: center;
  line-height: 3vh;
  margin-bottom: 0;
  font-size: 0.55vw;
  // background-color: #fff;
}
.clearbtn {
  height: 2vh;
  font-size: 0.55vw !important;
}
.event-btn {
  margin-top: 10px;
  .flexColumnCenter();
  width: 2vw;
  background-color: rgb(25, 35, 78);
  padding: 3px 2px;
  border-radius: 3px;
  cursor: pointer;
  top: 0;
  right: 0;
  position: absolute;
  & span {
    width: 1vw;
    text-align: center;
    font-size: 0.55vw;
    color: #ffffff;
  }
  .icon {
    width: 0.55vw;
    height: 0.55vw;
    font-size: 0.5vw;
    .flexCenter();
  }
}
.pagination {
  width: 100%;
  margin-top: 0.2vw;
  padding: 0 0.1vw;
  text-align: right;
}
/deep/ .ant-pagination-total-text {
  font-size: 0.5vw;
  margin-right: 0.5vw;
  margin-bottom: 0.5vw;
  width: 100%;
  padding-right: 0.5vw;
  color: white;
}
/deep/ .anticon-left,
/deep/ .anticon-right {
  color: #fff;
  font-size: 0.5vw;
}
/deep/ .ant-timeline-item-tail {
  border-left: 0.1vw solid #9e0b0b;
  // font-size: 0.5vw;
}
/deep/ .ant-timeline-item-head {
  background-color: #000033;
  // opacity: 0.8;
}
.mpflex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.redo {
  font-size: 0.6vw;
  &:hover {
    cursor: pointer;
  }
}
.line {
  width: 100%;
  height: 2vh;
  margin-top: 1.5vw;
  background-color: #000033;
  opacity: 0.9;
  display: flex;
  justify-content: center;
  font-size: 0.55vw;
  &:hover {
    cursor: pointer;
  }
  .icon {
    transform: rotate(-90deg);
    font-size: 0.55vw;
  }
  .icon1 {
    transform: rotate(90deg);
    font-size: 0.55vw;
  }
}

//区域左边card过渡
.left-card-enter-active,
.left-card-leave-active {
  transition: all 0.3s ease;
}
// .left-card-leave-active {
//   transition: all .2s ease;
// }
.left-card-enter,
.left-card-leave-to {
  transform: translateY(-600px);
  opacity: 0;
}

//区域右边card过渡
.right-card-enter-active {
  transition: all 0.3s ease;
}
.right-card-leave-active {
  transition: all 0.1s ease;
}
.right-card-enter,
.right-card-leave-to {
  transform: translateX(-340px);
  opacity: 0;
}

//事件列表过渡
.event-list-enter-active,
.event-list-leave-active {
  transition: all 0.3s ease;
}
.event-list-enter,
.event-list-leave-to {
  transform: translateX(230px);
  // width: 340px;
  // opacity: 0;
}

//事件按钮过渡
.event-btn-enter-active,
.event-btn-leave-active {
  transition: all 2s ease;
}
.event-btn-enter,
.event-btn-leave-to {
  opacity: 0;
}
.nodata {
  font-size: 0.5vw;
}
/deep/ .ant-checkbox-inner {
  border-radius: 50% !important;
}
</style>



// WEBPACK FOOTER //
// src/views/bigscreen/monitor/MonitorView.vue